module.exports = __webpack_public_path__ + "static/media/symlink.f7c4bdef.svg";